import { defineNuxtPlugin, useCookie, useRequestEvent, useRuntimeConfig } from "#imports";
import { Agent } from "#sitis/internal/agent/Agent";
import { GetContentUseCase } from "#sitis/internal/controllers/cms/useCase/GetContentUseCase";
import { GetProductUseCase } from "#sitis/internal/controllers/products/useCase/GetProductUseCase";
import { GetCategoriesUseCase } from "#sitis/internal/controllers/categories/useCase/GetCategoriesUseCase";
import { CartUseCase } from "#sitis/internal/controllers/cart/useCase/CartUseCase";
import { FiltersUseCase } from "#sitis/internal/controllers/filters/useCase/FiltersUseCase";
import { handleWordDeclension } from "#sitis/plugins/handleWordDeclension";
import { WishUseCase } from "#sitis/internal/controllers/wish/useCase/WishUseCase";
import { priceFormat } from "#sitis/plugins/priceFormat";
import { UserUseCase } from "#sitis/internal/controllers/user/useCase/UserUseCase";
export default defineNuxtPlugin(() => {
  const { options } = useRuntimeConfig().public.sitis;
  const defaultCookiesSettings = {
    maxAge: 60 * 60 * 24 * 30 * 12,
    path: "/",
    domain: options.baseCookieDomain
  };
  const event = useRequestEvent();
  const req = event?.node?.req;
  const isServer = process.server;
  const host = process.client ? window.location.host : req?.headers?.host;
  const isLocalHost = Boolean((host || "").includes("localhost:"));
  const authToken = useCookie("authToken", { ...defaultCookiesSettings });
  const sessionToken = useCookie("sessionToken", { ...defaultCookiesSettings });
  if (!sessionToken.value) {
    sessionToken.value = `f-${[...Array(11)].map(() => (~~(Math.random() * 36)).toString(36)).join("")}`;
  }
  const config = {
    baseUrl: options.baseUrl,
    headers: {}
  };
  if (authToken.value) {
    config.headers.Authorization = `Bearer ${authToken.value}`;
  }
  if (sessionToken.value) {
    config.headers["x-session-token"] = sessionToken.value;
  }
  if (isServer && req) {
    config.headers.origin = `https://${req?.headers?.host || ""}`;
    if (!isLocalHost) {
      config.headers["user-agent"] = req?.headers["user-agent"];
      config.headers["x-forwarded-host"] = req?.headers?.host || "";
      config.headers["x-forwarded-for"] = req?.headers?.["x-forwarded-for"] || "";
    }
  }
  if (!isServer && !isLocalHost) {
    config.headers["x-forwarded-host"] = window?.location?.host || "";
  }
  const agent = new Agent(config);
  const api = {
    productsApi: new GetProductUseCase(agent),
    cmsContentApi: new GetContentUseCase(agent),
    categoriesApi: new GetCategoriesUseCase(agent),
    cartApi: new CartUseCase(agent),
    filterApi: new FiltersUseCase(agent),
    wishApi: new WishUseCase(agent),
    userApi: new UserUseCase(agent),
    agent
  };
  return {
    provide: {
      api,
      handleWordDeclension,
      priceFormat
    }
  };
});
